import { render } from "./addbuilding.vue?vue&type=template&id=c438a9a8&scoped=true"
import script from "./addbuilding.vue?vue&type=script&lang=js"
export * from "./addbuilding.vue?vue&type=script&lang=js"

import "./addbuilding.vue?vue&type=style&index=0&id=c438a9a8&lang=scss&scoped=true"
import "./addbuilding.vue?vue&type=style&index=1&id=c438a9a8&lang=scss"

import exportComponent from "/Users/arvindersingh/Desktop/projects/parsoftwares/rt-backend/backend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c438a9a8"]])

export default __exports__